import { createI18n } from 'vue-i18n';
import type { I18n } from 'vue-i18n';
import { detectLanguage, setLanguage, type SupportedLanguage } from '@/utils/language';

// 默认语言包
import sc from './sc';
import jp from './ja';

// 定义语言包类型
type MessageSchema = typeof sc;

const messages: Record<SupportedLanguage, MessageSchema> = {
  sc,
  jp
};

// 创建 i18n 实例
const i18n = createI18n<[MessageSchema], SupportedLanguage>({
  legacy: false, // 使用组合式API
  locale: 'sc', // 默认语言
  fallbackLocale: 'sc', // 回退语言
  messages, // 默认加载所有语言包
  globalInjection: true, // 全局注入 $t 等方法
});

// 初始化语言设置
export const initializeLanguage = async () => {
  try {
    const detectedLang = await detectLanguage();
    await setLanguage(i18n as I18n, detectedLang);
  } catch (error) {
    console.error('初始化语言设置失败:', error);
  }
};

// 切换语言的辅助函数
export const switchLanguage = async (lang: SupportedLanguage) => {
  await setLanguage(i18n as I18n, lang);
};

export default i18n; 